<template>
  <v-app-bar app
             :color="isTestEnvironment ? 'red darken-4' :''"
             elevation="0"
             outlined
             style="background-color: white;">
    <!--                 clipped-left-->
    <v-toolbar-title class="font-weight-black"
                     :class="$vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h6'">
      <v-sheet rounded>
        <v-row no-gutters
               class="align-center px-1">
          <v-col class="flex-grow-0">
            <v-img v-if="$vuetify.breakpoint.mdAndUp"
                   :src="logoText"
                   max-height="48"
                   max-width="260"
                   class="d-inline-block" />
            <v-img v-else
                   :src="logo"
                   max-height="48"
                   max-width="48"
                   class="d-inline-block" />
          </v-col>
          <v-col>
            <span style="color:#FE5000;">Parcels</span>
          </v-col>
        </v-row>
      </v-sheet>
    </v-toolbar-title>
    <v-row dense
           align="center">
      <v-col />
      <v-col v-if="isTestEnvironment"
             class="flex-grow-0">
        <v-row class="flex-nowrap"
               align="center">
          <v-col class="flex-grow-0">
            <v-icon large>
              mdi-alert
            </v-icon>
          </v-col>
          <v-col>
            TEST ENVIRONMENT
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="isDev"
             class="flex-grow-0">
        <current-size color="primary" />
      </v-col>
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown"
                          @click.stop="drawer = !drawer" />
      <v-col class="flex-grow-0 d-flex">
        <user-manual-button />
        <logout-button />
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import {mapMutations} from 'vuex';
import CurrentSize from '@/components/Navigation/Header/CurrentSize';
import {TEST_ENVIRONMENT} from '@/config';
import LogoutButton from '@/components/Navigation/Header/LogoutButton.vue';
import UserManualButton from '@/components/Navigation/Header/UserManualButton.vue';
import logoText from '@/assets/logo_text.svg';
import logo from '@/assets/logo.svg';

export default {
  name: 'AppHeader',
  components: {LogoutButton, CurrentSize, UserManualButton},
  data () {
    return {
      logo,
      logoText,
    };
  },
  computed: {
    isDev () {
      return process.env.NODE_ENV === 'development';
    },
    isTestEnvironment () {
      return TEST_ENVIRONMENT;
    },
    client: {
      get () {
        return this.$store.getters['mode/client'];
      },
    },
    drawer: {
      get () {
        return this.$store.state.options.drawerOpen;
      },
      set (val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      darkMode: 'options/switchDarkTheme',
      setDrawer: 'options/setDrawer',
    }),
  },
};
</script>

<style scoped>

</style>
